<template>
  <div>
    <b-row class="mb-4">
      <b-col cols="12" offset-sm="1" sm="10">
        <h3>
          {{ $t('settings.project.projectType.themeSetting.title') }}
          -
          {{ $t('settings.project.projectType.themeSetting.direct_top_bmw.name') }}
        </h3>
        <hr>
      </b-col>
    </b-row>
    <component
      v-for="(themeConfigItem, index) in themeFieldConfig"
      :key="index"
      :is="themeConfigItem.fieldType"
      :handle="themeConfigItem.handle"
      :label="themeConfigItem.title"
      :desc="themeConfigItem.desc"
      :value-from-db="themeValues[themeConfigItem.handle]"
      @update-field="updateSettingValue($event, themeConfigItem.handle)"
    />
  </div>
</template>

<script>
import ImageUploadRow from '@/components/helper/ImageUploadRow.vue';
import CheckboxRow from '@/components/helper/CheckboxRow.vue';
import InputRow from '@/components/helper/InputRow.vue';

export default {
  name: 'ThemeSettingsDirectTopBmw',
  components: {
    CheckboxRow,
    ImageUploadRow,
    InputRow,
  },
  props: {
    settingValues: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      themeFieldConfig: [
        {
          handle: 'logoimage',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.logoimage.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.logoimage.desc'),
          fieldType: 'ImageUploadRow',
        },
        {
          handle: 'show_logo',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.show_logo.title'),
          desc: null,
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'title',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.title.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.title.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'article',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.article.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.article.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'scrollMenu',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.scrollMenu.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.scrollMenu.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'search',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.search.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.search.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'shadow',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.shadow.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.shadow.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'pagination',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.pagination.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.pagination.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'show_borders',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.show_borders.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.show_borders.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'navigation',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.navigation.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.navigation.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'navigation_hide',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.navigation_hide.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.navigation_hide.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'navigation_position',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.navigation_position.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.navigation_position.desc'),
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'sharing',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.sharing.title'),
          desc: null,
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'sharing_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.sharing_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.sharing_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'cookies',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.cookies.title'),
          desc: null,
          fieldType: 'CheckboxRow',
        },
        {
          handle: 'cookies_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.cookies_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.cookies_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'facebook',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.facebook.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.facebook.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'facebook_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.facebook_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.facebook_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'twitter',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.twitter.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.twitter.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'twitter_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.twitter_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.twitter_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'instagram',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.instagram.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.instagram.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'instagram_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.instagram_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.instagram_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'linkedin',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.linkedin.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.linkedin.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'linkedin_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.linkedin_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.linkedin_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'xing',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.xing.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.xing.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'xing_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.xing_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.xing_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'youtube',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.youtube.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.youtube.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'youtube_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.youtube_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.youtube_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'website',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.website.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'website_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.website_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.website_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'print',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.print.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'print_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.print_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.print_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'overview',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.overview.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'overview_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.overview_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.overview_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'imprint',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.imprint.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'imprint_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.imprint_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.imprint_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'dataprivacy',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.dataprivacy.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'dataprivacy_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.dataprivacy_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.dataprivacy_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'custom1',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom1.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'custom1_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom1_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom1_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'custom1_icon',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom1_icon.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom1_icon.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'custom2',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom2.title'),
          desc: null,
          fieldType: 'InputRow',
        },
        {
          handle: 'custom2_tooltip',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom2_tooltip.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom2_tooltip.desc'),
          fieldType: 'InputRow',
        },
        {
          handle: 'custom2_icon',
          title: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom2_icon.title'),
          desc: this.$t('settings.project.projectType.themeSetting.direct_top_bmw.custom2_icon.desc'),
          fieldType: 'InputRow',
        },
      ],
      themeValues: {
        logoimage: {
          url: null,
          width: null,
          height: null,
          focalpoint: {
            x: 50,
            y: 50,
          },
        },
        title: null,
        article: false,
        show_logo: true,
        scrollMenu: false,
        search: false,
        navigation: true,
        navigation_hide: false,
        navigation_position: false,
        show_borders: false,
        shadow: false,
        pagination: false,
        sharing: true,
        sharing_tooltip: null,
        cookies: true,
        cookies_tooltip: null,
        facebook: null,
        facebook_tooltip: null,
        twitter: null,
        twitter_tooltip: null,
        instagram: null,
        instagram_tooltip: null,
        linkedin: null,
        linkedin_tooltip: null,
        xing: null,
        xing_tooltip: null,
        youtube: null,
        youtube_tooltip: null,
        website: null,
        website_tooltip: null,
        print: null,
        print_tooltip: null,
        overview: null,
        overview_tooltip: null,
        imprint: null,
        imprint_tooltip: null,
        dataprivacy: null,
        dataprivacy_tooltip: null,
        custom1: null,
        custom1_tooltip: null,
        custom1_icon: 'fa-heart',
        custom2: null,
        custom2_tooltip: null,
        custom2_icon: 'fa-heart',
      },
    };
  },
  created() {
    // add the values to the data
    if (this.settingValues) {
      // eslint-disable-next-line array-callback-return
      Object.entries(this.settingValues).map((itemValue) => {
        const key = itemValue[0];
        const value = itemValue[1];
        if (this.themeValues.hasOwnProperty(key)) {
          this.themeValues[key] = value;
        }
      });
      if (this.themeValues.logoimage.url) {
        if (!this.$checkForCloudImage(this.themeValues.logoimage.url)) {
          this.themeValues.logoimage.url = this.$makeCloudImage(
            this.themeValues.logoimage.url,
            { width: 450, height: 300 },
            this.themeValues.logoimage,
          );
        }
      }
    }
    this.$emit('update-theme-settings', this.themeValues);
  },
  methods: {
    updateSettingValue(value, handle) {
      if (this.themeValues.hasOwnProperty(handle)) {
        this.themeValues[handle] = value;
        this.$emit('update-theme-settings', this.themeValues);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
